import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslateModule],
  template: `
    <footer class="bg-dark-100 border-t border-white/[0.04] py-8">
      <div class="max-w-7xl mx-auto px-5 md:px-10">
        <div class="flex flex-col md:flex-row justify-between items-center gap-4">
          
          <a href="#" class="flex items-center gap-1">
            <img src="logo.png" alt="COLORFOL" class="h-4" />
          </a>

          <div class="flex gap-5 text-xs text-gray-550">
            <a href="#" class="hover:text-white transition-colors">{{ 'FOOTER.TERMS' | translate }}</a>
            <a href="#" class="hover:text-white transition-colors">{{ 'FOOTER.PRIVACY' | translate }}</a>
            <a href="#" class="hover:text-white transition-colors">{{ 'FOOTER.CONTACT' | translate }}</a>
          </div>

          <p class="text-[11px] text-gray-650">{{ 'FOOTER.COPYRIGHT' | translate }}</p>
        </div>
      </div>
    </footer>
  `
})
export class FooterComponent {}
